import { Navigate, useLocation } from "react-router-dom";
import { getResponsibleName } from "../../helperFunctions";
import { canSeePath } from "../Header/navAccess";

// Wraps a route element and redirects to /401 when the current role is not
// allowed to view the path (see navAccess.js). This is a UI guard only — the
// backend route guards remain the real enforcement.
export default function RequireAccess({ children }) {
  const { pathname } = useLocation();
  const role = getResponsibleName();

  if (!canSeePath(pathname, role)) {
    return <Navigate to="/401" replace />;
  }
  return children;
}
